<div class="container">
  <mat-card>
    <form [formGroup]="chargeForm" (ngSubmit)="submit()">
      <mat-card-content>
        <div class="layout-row-wrap gap-2px responsive-column">
          <mat-form-field class="flex-48">
            <mat-label>{{ 'labels.inputs.Charge Applies To' | translate }}</mat-label>
            <mat-select required formControlName="chargeAppliesTo">
              @for (chargeAppliesTo of chargeData.chargeAppliesToOptions; track chargeAppliesTo) {
                <mat-option [value]="chargeAppliesTo.id">
                  {{ chargeAppliesTo.value | translateKey: 'catalogs' }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>

        <div class="layout-row-wrap gap-2percent layout-lt-md-column form-section">
          <mat-form-field class="flex-48">
            <mat-label>{{ 'labels.inputs.Name' | translate }}</mat-label>
            <input matInput required autofocus formControlName="name" />
            @if (chargeForm.controls.name.hasError('required')) {
              <mat-error>
                {{ 'labels.inputs.Name' | translate }} {{ 'labels.commons.is' | translate }}
                <strong>{{ 'labels.commons.required' | translate }}</strong>
              </mat-error>
            }
          </mat-form-field>

          <mat-form-field class="flex-48">
            <mat-label>{{ 'labels.inputs.Currency' | translate }}</mat-label>
            <mat-select required formControlName="currencyCode">
              @for (currency of chargeData.currencyOptions; track currency) {
                <mat-option [value]="currency.code">
                  {{ currency.name }}
                </mat-option>
              }
            </mat-select>
            @if (chargeForm.controls.currencyCode.hasError('required')) {
              <mat-error>
                {{ 'labels.inputs.Currency' | translate }} {{ 'labels.inputs.Type' | translate }}
                {{ 'labels.commons.is' | translate }} <strong>{{ 'labels.commons.required' | translate }}</strong>
              </mat-error>
            }
          </mat-form-field>

          <mat-form-field class="flex-48">
            <mat-label>{{ 'labels.inputs.Charge Time Type' | translate }}</mat-label>
            <mat-select required formControlName="chargeTimeType">
              @for (chargeTime of chargeTimeTypeOptions; track chargeTime) {
                <mat-option [value]="chargeTime.id">
                  {{ chargeTime.value | translateKey: 'catalogs' }}
                </mat-option>
              }
            </mat-select>
            @if (chargeForm.controls.chargeTimeType.hasError('required')) {
              <mat-error>
                {{ 'labels.inputs.Charge Time Type' | translate }} {{ 'labels.commons.is' | translate }}
                <strong>{{ 'labels.commons.required' | translate }}</strong>
              </mat-error>
            }
          </mat-form-field>

          <mat-form-field class="flex-48">
            <mat-label>{{ 'labels.inputs.Charge Calculation' | translate }}</mat-label>
            <mat-select required formControlName="chargeCalculationType">
              @for (chargeCalculation of chargeCalculationTypeOptions; track chargeCalculation) {
                <mat-option [value]="chargeCalculation.id">
                  {{ chargeCalculation.value | translateKey: 'catalogs' }}
                </mat-option>
              }
            </mat-select>
            @if (chargeForm.controls.chargeCalculationType.hasError('required')) {
              <mat-error>
                {{ 'labels.inputs.Charge Calculation Type' | translate }} {{ 'labels.commons.is' | translate }}
                <strong>{{ 'labels.commons.required' | translate }}</strong>
              </mat-error>
            }
          </mat-form-field>

          @if (chargePaymentMode) {
            <mat-form-field class="flex-48">
              <mat-label>{{ 'labels.inputs.Charge Payment By' | translate }}</mat-label>
              <mat-select required formControlName="chargePaymentMode">
                @for (chargePaymentMode of chargeData.chargePaymetModeOptions; track chargePaymentMode) {
                  <mat-option [value]="chargePaymentMode.id">
                    {{ chargePaymentMode.value | translateKey: 'catalogs' }}
                  </mat-option>
                }
              </mat-select>
              @if (chargeForm.controls.chargePaymentMode.hasError('required')) {
                <mat-error>
                  {{ 'labels.inputs.Charge Payment Mode' | translate }} {{ 'labels.commons.is' | translate }}
                  <strong>{{ 'labels.commons.required' | translate }}</strong>
                </mat-error>
              }
            </mat-form-field>
          }

          <mat-form-field class="flex-48">
            <mat-label>{{ 'labels.inputs.Amount' | translate }}</mat-label>
            <input matInput required autofocus type="text" formControlName="amount" />
            @if (chargeForm.controls.amount.hasError('required')) {
              <mat-error>
                {{ 'labels.inputs.Amount' | translate }} {{ 'labels.commons.is' | translate }}
                <strong>{{ 'labels.commons.required' | translate }}</strong>
              </mat-error>
            }
          </mat-form-field>
          <!--
          * minCap and maxCap only allowed for loan ,shares and savings entitites
          * In Loan case: Only for the "charge calculation type" set as "%amount", "% loan amount+interest", "%interest",and "%disbursement amount".
          * In saving case: Only for 1. charge time type is "withdrawlfee" or "savings no activity fee" with charge calculation type as "% amount"
          * In shares case: Only for charge time type: SHARE_PURCHASE and SHARE_REDEEM and with charge calculation type as % amount only
          -->
          @if (
            (chargeForm.controls.chargeAppliesTo.value === 1 &&
              (chargeForm.controls.chargeCalculationType.value === 2 ||
                chargeForm.controls.chargeCalculationType.value === 3 ||
                chargeForm.controls.chargeCalculationType.value === 4 ||
                chargeForm.controls.chargeCalculationType.value === 5)) ||
            (chargeForm.controls.chargeAppliesTo.value === 2 &&
              (chargeForm.controls.chargeTimeType.value === 16 || chargeForm.controls.chargeTimeType.value === 5) &&
              chargeForm.controls.chargeCalculationType.value === 2) ||
            (chargeForm.controls.chargeAppliesTo.value === 4 &&
              (chargeForm.controls.chargeTimeType.value === 14 || chargeForm.controls.chargeTimeType.value === 15) &&
              chargeForm.controls.chargeCalculationType.value === 2)
          ) {
            <mat-form-field class="flex-48">
              <mat-label>{{ 'labels.inputs.Minimum Charge Cap' | translate }}</mat-label>
              <input matInput autofocus formControlName="minCap" LOSxValidateOnFocus />
              @if (chargeForm.controls.minCap.hasError('maxValue')) {
                <mat-error>
                  {{ 'errors.validation.msg.loanproduct.minimumGap.not.greater.than.specified.number' | translate }} ({{
                    chargeForm.controls.maxCap.value
                  }})
                </mat-error>
              }
            </mat-form-field>
          }
          @if (
            (chargeForm.controls.chargeAppliesTo.value === 1 &&
              (chargeForm.controls.chargeCalculationType.value === 2 ||
                chargeForm.controls.chargeCalculationType.value === 3 ||
                chargeForm.controls.chargeCalculationType.value === 4 ||
                chargeForm.controls.chargeCalculationType.value === 5)) ||
            (chargeForm.controls.chargeAppliesTo.value === 2 &&
              (chargeForm.controls.chargeTimeType.value === 16 || chargeForm.controls.chargeTimeType.value === 5) &&
              chargeForm.controls.chargeCalculationType.value === 2) ||
            (chargeForm.controls.chargeAppliesTo.value === 4 &&
              (chargeForm.controls.chargeTimeType.value === 14 || chargeForm.controls.chargeTimeType.value === 15) &&
              chargeForm.controls.chargeCalculationType.value === 2)
          ) {
            <mat-form-field class="flex-48">
              <mat-label>{{ 'labels.inputs.Maximum Charge Cap' | translate }}</mat-label>
              <input matInput autofocus formControlName="maxCap" LOSxValidateOnFocus />
              @if (chargeForm.controls.maxCap.hasError('minValue')) {
                <mat-error>
                  {{ 'errors.validation.msg.loanproduct.maximumGap.not.greater.than.specified.number' | translate }} ({{
                    chargeForm.controls.minCap.value
                  }})
                </mat-error>
              }
            </mat-form-field>
          }

          @if (showGLAccount) {
            <LOSx-gl-account-selector
              class="flex-48"
              [inputFormControl]="chargeForm.controls.incomeAccountId"
              [glAccountList]="chargeData.incomeOrLiabilityAccountOptions.incomeAccountOptions"
              [required]="true"
              [inputLabel]="'Income from Charge'"
            >
            </LOSx-gl-account-selector>
          }

          <mat-form-field class="flex-48">
            <mat-label>{{ 'labels.inputs.Tax Group' | translate }}</mat-label>
            @if (chargeData.taxGroup) {
              <mat-select formControlName="taxGroupId">
                @for (taxGroup of chargeData.taxGroupOptions; track taxGroup) {
                  <mat-option [value]="taxGroup.id">
                    {{ taxGroup.name }}
                  </mat-option>
                }
              </mat-select>
            }

            @if (!chargeData.taxGroup) {
              <mat-select formControlName="taxGroupId">
                @for (taxGroup of chargeData.taxGroupOptions; track taxGroup) {
                  <mat-option [value]="taxGroup.id">
                    {{ taxGroup.name }}
                  </mat-option>
                }
              </mat-select>
            }
          </mat-form-field>

          @if (addFeeFrequency) {
            <div class="password-never-expires-wrapper checkbox flex-48">
              <mat-checkbox
                labelPosition="before"
                [checked]="addFeeFrequency && showFeeOptions"
                (change)="getFeeFrequency($event.checked)"
              >
                {{ 'labels.inputs.Add Fee Frequency' | translate }}
              </mat-checkbox>
            </div>
          }

          @if (addFeeFrequency && showFeeOptions) {
            <mat-form-field class="flex-48">
              <mat-label>{{ 'labels.inputs.Frequency Interval' | translate }}</mat-label>
              <input matInput required autofocus type="text" formControlName="feeInterval" />
              @if (chargeForm.controls.feeInterval.hasError('required')) {
                <mat-error>
                  {{ 'labels.inputs.Frequency Interval' | translate }} {{ 'labels.commons.is' | translate }}
                  <strong>{{ 'labels.commons.required' | translate }}</strong>
                </mat-error>
              }
            </mat-form-field>
          }

          @if (addFeeFrequency && showFeeOptions) {
            <mat-form-field class="flex-48">
              <mat-label>{{ 'labels.inputs.Charge Frequency' | translate }}</mat-label>
              <mat-select required formControlName="feeFrequency">
                @for (chargeFrequency of chargeData.feeFrequencyOptions; track chargeFrequency) {
                  <mat-option [value]="chargeFrequency.id">
                    {{ chargeFrequency.value | translateKey: 'catalogs' }}
                  </mat-option>
                }
              </mat-select>
              @if (chargeForm.controls.feeFrequency.hasError('required')) {
                <mat-error>
                  {{ 'labels.inputs.Add Fee Frequency' | translate }} {{ 'labels.commons.is' | translate }}
                  <strong>{{ 'labels.commons.required' | translate }}</strong>
                </mat-error>
              }
            </mat-form-field>
          }
        </div>

        <div class="layout-row-wrap gap-2percent layout-lt-md-column form-section">
          <div class="password-never-expires-wrapper flex-48">
            <mat-checkbox labelPosition="before" formControlName="active">
              {{ 'labels.status.Active' | translate }}
            </mat-checkbox>
          </div>

          @if (showPenalty) {
            <div class="send-password-to-email-wrapper flex-48">
              <mat-checkbox labelPosition="before" formControlName="penalty">
                {{ 'labels.commons.Is' | translate }} {{ 'labels.inputs.Penalty' | translate }}
              </mat-checkbox>
            </div>
          }
        </div>
      </mat-card-content>

      <mat-card-actions class="layout-row align-center gap-5px responsive-column">
        <button type="button" mat-raised-button [routerLink]="['../']">
          {{ 'labels.buttons.Cancel' | translate }}
        </button>
        <button mat-raised-button color="primary" [disabled]="!chargeForm.valid" *LOSxHasPermission="'UPDATE_CHARGE'">
          {{ 'labels.buttons.Submit' | translate }}
        </button>
      </mat-card-actions>
    </form>
  </mat-card>
</div>
